module.exports = __webpack_public_path__ + "assets/f8fa8e2bb4ab882c3c6f8a33797af34b.png";